export default {
  auth: {
    login: "/login",
    logout: "/admin/logout",
  },
  user: {
    getUsers: "users",
    getDocUsers: "users-dropdown",
    create: "user",
    update: "user",
    delete: "user",
    sendInvitation: "user/send-invitation",
    register: "user/register",
    resetPassword: "user/reset-password",
    forgotPassword: "user/send-reset-password",
  },
  common: {},
  documents: {
    index: "docuhub-document",
  },
  dashboard: {
    getDashboardData: "admin/get-dashboard",
    getPaymentDetails: "admin/get-payment-details",
  },
  members: {},
  web: {
    getSettings: "admin/get-web-settings",
    updateSettings: "admin/update-web-settings",
  },
};
